import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=362cde3f&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"
import style0 from "./page1.vue?vue&type=style&index=0&id=362cde3f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362cde3f",
  null
  
)

export default component.exports